
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Card, CardTitle, CardSubtitle, Button } from 'reactstrap';

//Components
import TextField from '../../../components/TextField';
import EsqueceuSenhaRestrito from './Components/EsqueceuSenhaRestrito';

//Context
import { useAuth } from '../../../context/auth';

//Api
import usuario_api from '../../../api/usuario_api';

//Helpers
import { showMessage } from '../../../helpers/message';

export default function LoginRestrito() {
    const navigate = useNavigate();
    const { signIn, setLoading } = useAuth();
    //Estado de controle dos dados de login
    const [login, setLogin] = useState({
        username: "",
        password: ""
    });

    const [esqueceuSenha, setEsqueceuSenha] = useState(false);
    //Função de onChange dos campos da tela inicial
    const onChange = (e) => {
        const { name, value } = e.target;
        setLogin({
            ...login,
            [name]: value
        })
    }

    //Função que envia os dados do login para validação
    const onSubmit = () => {
        setLoading(true);
        usuario_api.authenticateRestrito(login).then(response => {
            signIn(response.data);
            navigate("/admin/dashboard");
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));

    }

    if (esqueceuSenha)
        return <EsqueceuSenhaRestrito btnVoltar={() => setEsqueceuSenha(false)} />
    return (
        <div className='mainContainerLogin'>
            <Card className='w-75' style={{ marginTop: "10vh", border: "none", padding: "1rem" }}>
                <Row className='p-4'>
                    <Col lg='6' md='12' className='text-center d-flex flex-column justify-content-center' style={{ borderRight: "1px solid #ccc" }}>
                        <div className="mb-3">
                            <img src={require('../../../assets/img/logo.png')} className='img-logo' alt="logo do sistema GAIA" />
                        </div>
                        <CardTitle tag={'h4'} style={{ color: "#666" }} className='mb-2 font-weight-normal'>Seja bem vindo ao GAIA </CardTitle>
                        <CardSubtitle tag="p" style={{ color: "#ccc", fontSize: '16pt' }} className='mb-2'>
                            Sistema de Gestão Arbórea
                        </CardSubtitle>
                        <CardSubtitle tag="p" style={{ color: "#ccc", fontSize: '14pt' }} className='mb-4  d-flex align-items-center justify-content-center fw-bold text-warning'>
                            Área Restrita
                        </CardSubtitle>
                    </Col>
                    <Col lg='6' md='12' className='text-center d-flex flex-column justify-content-around '>
                        <CardTitle tag={'h4'} className=' text-center' style={{ color: "#666" }}>Dados de acesso</CardTitle>
                        <TextField label={"E-mail"} onChange={onChange} value={login.username} name={"username"} />
                        <TextField label={"Senha"} type={'password'} onChange={onChange} value={login.password} name={"password"} />
                        <div className='w-100 d-flex align-items-center justify-content-end text-secondary mb-3'>
                            <span role='button' onClick={() => setEsqueceuSenha(true)}>Esqueceu a senha?</span>
                        </div>
                        <div>
                            <Button color='success' style={{ width: "80%" }} onClick={onSubmit}>
                                Entrar
                            </Button>
                        </div>
                    </Col>

                </Row>
            </Card>
        </div>
    )
}